import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { Icon, RadioButton, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import { getThemeImages } from '../../../Themes';

import styles from './SettingsRadio.styles';

function SettingsRadio({ icon, title, isSelected, onPress, images }) {
  const theme = useTheme();
  const Images = images || getThemeImages(theme.name);

  return (
    <View style={styles.radioContainer} testID={FrameworkTestKeys.settingsRadioView}>
      <View style={styles.iconTextContainer} testID={FrameworkTestKeys.settingsRadioTextView}>
        <Icon
          type="image"
          source={Images[icon] ?? { uri: icon }}
          size={32}
          style={styles.icon}
          testID={FrameworkTestKeys.settingsRadioIcon}
        />
        <VFText
          type="primary"
          i18nKey={title}
          style={styles.text}
          testKey={FrameworkTestKeys.settingsRadioTitleText}
        />
      </View>

      <RadioButton
        testID={FrameworkTestKeys.settingsRadioButton}
        selected={isSelected}
        style={styles.radio}
        onPress={onPress}
      />
    </View>
  );
}

SettingsRadio.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  onPress: PropTypes.func.isRequired,
  images: PropTypes.object,
};

export default SettingsRadio;
